import { useState, useEffect } from 'react'
import SectionTitle from '../../common/SectionTitle'
import Slick from 'react-slick'

import './_FeaturesSection.scss'

import icon1 from '../../../assets/images/icons/headphones.svg'
import icon2 from '../../../assets/images/icons/heart.svg'
import icon3 from '../../../assets/images/icons/smile.svg'
import icon4 from '../../../assets/images/icons/reward.svg'
import icon5 from '../../../assets/images/icons/warning.svg'
import icon6 from '../../../assets/images/icons/notes.svg'
import icon7 from '../../../assets/images/icons/chat.svg'
import icon8 from '../../../assets/images/icons/mark.svg'

const FeatureCard = ({ img, title, text }) => (
  <div className='feature-card gradient-border'>
    <div className='card-main gradient-border-content'>
      <div className="icon-box center">
        <img src={img} alt={title} className='icon' />
      </div>
      <div className='text-box'>
        <h4 className='title'>{title}</h4>
        <p className='text'>{text}</p>
      </div>
    </div>
  </div>
)

const featuresCards = [{
  img: icon1,
  title: 'Support 24/7',
  text: 'Our doctors will always give you instant feedback',
}, {
  img: icon2,
  title: 'Health support',
  text: 'We take care of your health, you don`t have to worry',
}, {
  img: icon3,
  title: 'good habits',
  text: 'With us you will never forget good habits',
}, {
  img: icon4,
  title: 'target circle',
  text: 'Close your goals daily and look at your achievements',
}, {
  img: icon5,
  title: 'information push',
  text: 'You can receive information about your health',
}, {
  img: icon6,
  title: 'prescription',
  text: 'You can get a prescription online',
}, {
  img: icon7,
  title: 'online chat',
  text: 'Get an online consultation with your doctor',
}, {
  img: icon8,
  title: 'online entry',
  text: 'Sign up online at any time for you',
}]

const FeaturesSection = () => {
  const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)

  const resizeWindow = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', resizeWindow)

    return () => window.removeEventListener('resize', resizeWindow)
  })

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <div className='FeaturesSection section-padding' id='features'>
      <div className='container'>
        <SectionTitle
          title='Our Features'
          text='Axelerate includes many handy features'
          sm
        />
        <div className='slider-box'>
          { windowWidth < 834 ?
            <Slick {...settings}>
              {Array(featuresCards.length / 2).fill(0).map((_, i) => (
                <div className='two-cards' key={featuresCards[i].title}>
                  <FeatureCard {...featuresCards[i + i]} />
                  <FeatureCard {...featuresCards[i + i + 1]} />
                </div>
              ))}
            </Slick> :
            featuresCards.map(card => <FeatureCard {...card} key={card.title} />)
          }
        </div>
      </div>
    </div>
  )
}

export default FeaturesSection
